module.exports = __webpack_public_path__ + "img/wall_old_tristram.f51a0123.jpg";